const HeaderStyles = {
  headerContainer: {
    width: "100%",
    height: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 14px 0px #00000014",
    padding: "0px 30px",
    position: "sticky",
    top: "0",
    zIndex: 1000,
  },
  welcomeText: {
    color: "#383D4E",
    fontSize: "20px",
    fontWeight: 400,
    fontFamily: "Playfair Display",
  },
  headerItems: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },
  notificationIcon: { width: "36px", height: "auto" },
  displayPicture: { width: "32px", height: "auto" },
  menuIcon: { width: "40px", height: "auto" },
};

export default HeaderStyles;
